var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.listReadable,"headers":_vm.headers,"no-data-text":"You have no proxies"},scopedSlots:_vm._u([{key:"item.actions",fn:function({ item }){return [_c('v-btn',{attrs:{"color":"error","icon":"","outlined":""},on:{"click":function($event){return _vm.deleteProxy(item)}}},[_c('v-icon',[_vm._v("mdi-delete")])],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }